"use client";

import { useState } from "react";
import { Plus, X } from "lucide-react";

export default function FaqSection() {
  const faqs = [
    {
      q: "What is EchoLeads?",
      a: "EchoLeads is AI voice sales software that automates outbound and inbound phone calls. It talks in a human-like voice to qualify leads, book appointments, run demos and follow up, 24/7.",
    },
    {
      q: "Will EchoLeads replace my sales team?",
      a: "No. It takes over repetitive work like qualification and follow-ups, so your team can focus on high-intent conversations and closing.",
    },
    {
      q: "Can a person take over a call?",
      a: "Yes. EchoLeads works without human intervention, and a human handoff is available when you want your team to step in. The agent passes along the context, including objections and intent.",
    },
    {
      q: "Which channels does it cover?",
      a: "Phone calls, both inbound and outbound, plus WhatsApp and Instagram. There is also a customer care agent for support calls and callbacks.",
    },
    {
      q: "Which industries is it built for?",
      a: "Real estate, insurance, SaaS, healthcare, financial services and e-commerce, as well as B2B lead generation and appointment booking.",
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-20 lg:py-24 bg-[#F8FAFC] border-b border-slate-200/80">
      <div className="w-full max-w-[1200px] mx-auto px-8 relative z-10">
        <h2 className="text-3xl sm:text-4xl lg:text-[44px] font-extrabold text-slate-900 tracking-tight leading-[1.15] mb-10">
          Questions before you book
        </h2>

        <div className="border-t border-slate-200 divide-y divide-slate-200 max-w-3xl">
          {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div key={idx} className="py-6">
                <button
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between gap-4 text-left group cursor-pointer"
                >
                  <span className="text-base sm:text-lg font-bold text-slate-900 group-hover:text-slate-700 transition-colors">
                    {faq.q}
                  </span>
                  <span className="text-[#D97706] shrink-0">
                    {isOpen ? (
                      <X className="w-5 h-5" />
                    ) : (
                      <Plus className="w-5 h-5" />
                    )}
                  </span>
                </button>

                {isOpen && (
                  <div className="pt-4 pr-10 text-sm sm:text-base text-slate-600 leading-relaxed animate-in fade-in duration-200">
                    {faq.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
